/* 这里的路由表示没登录状态下侧边栏能显示哪些东西 */
export const publicRoutes = 
[
    {
        "id": "655565355835461",
        "pid": "0",
        "order": -102,
        "name": "排行榜",
        "IsHide": false,
        "IsButton": false,
        "path": "-",
        "Func": null,
        "iconCls": "fa-trophy",
        "meta": {
            "title": "排行榜",
            "requireAuth": true,
            "NoTabPage": false,
            "keepAlive": false,
            "icon": null
        },
        "children": [
            {
                "id": "655566300770373",
                "pid": "655565355835461",
                "order": 0,
                "name": "总排行榜",
                "IsHide": false,
                "IsButton": false,
                "path": "/",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "总排行榜",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "id": "655566300770374",
                "pid": "655565355835462",
                "order": 0,
                "name": "月排行榜",
                "IsHide": false,
                "IsButton": false,
                "path": "/Rank/RankMonthly",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "月排行榜",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "id": "655566300770374",
                "pid": "655565355835462",
                "order": 0,
                "name": "周排行榜",
                "IsHide": false,
                "IsButton": false,
                "path": "/Rank/RankWeekly",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "周排行榜",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "id": "655566300770374",
                "pid": "655565355835462",
                "order": 0,
                "name": "日排行榜",
                "IsHide": false,
                "IsButton": false,
                "path": "/Rank/RankDaily",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "日排行榜",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            }
        ]
    },
    {
        "id": "653701975273541",
        "pid": "0",
        "order": -94,
        "name": "商店",
        "IsHide": false,
        "IsButton": false,
        "path": "-",
        "Func": null,
        "iconCls": "fa-shopping-cart",
        "meta": {
            "title": "商店",
            "requireAuth": true,
            "NoTabPage": false,
            "keepAlive": false,
            "icon": null
        },
        "children": [
            {
                "id": "653701975273541",
                "pid": "0",
                "order": -94,
                "name": "装备",
                "IsHide": false,
                "IsButton": false,
                "path": "/Shop/index",
                "Func": null,
                "iconCls": " ",
                "meta": {
                    "title": "装备",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
            },
            {
                "order": 0,
                "name": "单位",
                "IsHide": false,
                "IsButton": false,
                "path": "/Shop/UnitShop",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "单位",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "order": 0,
                "name": "技能",
                "IsHide": false,
                "IsButton": false,
                "path": "/Shop/SkillShop",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "技能",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            }
        ]
    },
    {
        "id": "655784881688646",
        "pid": "0",
        "order": -91,
        "name": "我的",
        "IsHide": false,
        "IsButton": false,
        "path": "-",
        "Func": null,
        "iconCls": "fa-user",
        "meta": {
            "title": "我的",
            "requireAuth": true,
            "NoTabPage": false,
            "keepAlive": false,
            "icon": null
        },
        "children": [
            {
                "id": "655785213734982",
                "pid": "655784881688646",
                "order": 0,
                "name": "个人信息",
                "IsHide": false,
                "IsButton": false,
                "path": "/UserCenter/Profile",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "个人信息",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "id": "655785608245318",
                "pid": "655784881688646",
                "order": 0,
                "name": "已购商品",
                "IsHide": false,
                "IsButton": false,
                "path": "/UserCenter/Purchased",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "已购商品",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "order": 0,
                "name": "已购单位",
                "IsHide": false,
                "IsButton": false,
                "path": "/UserCenter/PurchasedUnit",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "已购单位",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            },
            {
                "order": 0,
                "name": "已购技能",
                "IsHide": false,
                "IsButton": false,
                "path": "/UserCenter/PurchasedSkill",
                "Func": null,
                "iconCls": "",
                "meta": {
                    "title": "已购技能",
                    "requireAuth": true,
                    "NoTabPage": false,
                    "keepAlive": false,
                    "icon": null
                },
                "children": null
            }
        ]
    }
]